exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".integral-order-detail-dialog .el-dialog__body{padding:8px 20px 20px;max-height:calc(92vh - 120px);overflow-y:auto}.aftersale-link-inline{margin-left:8px;padding:0;font-size:12px}", ""]);

// exports
